<template>
  <div class="options_wrap">
    <div class="options_bar">
      <vuescroll :ops="ops" v-if="isMobile">
        <Controls></Controls>
      </vuescroll>

      <Controls v-else></Controls>

      <div class="shadows"></div>
    </div>

    <MobileExitPopUp />

    <MobileReactionsPopUp />
  </div>
</template>

<script>
import Controls from "@/components/Controls";
import MobileExitPopUp from "@/components/MobileExitPopUp";
import MobileReactionsPopUp from "@/components/MobileReactionsPopUp";
import vuescroll from "vuescroll";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,

      ops: {
        mode: "native",
        sizeStrategy: "percent",
        detectResize: true,

        bar: {
          opacity: 0,
        },

        rail: {
          opacity: 0,
        },
      },
    };
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },

  computed: {
    isMobile() {
      if (this.windowWidth <= 768) {
        return true;
      } else {
        return false;
      }
    },
  },

  components: {
    vuescroll,
    Controls,
    MobileExitPopUp,
    MobileReactionsPopUp,
  },
};
</script>

<style lang="scss" scoped>
.options_wrap {
  width: 100%;
  max-width: 100%;
}

.options_bar {
  margin-top: 16px;
  z-index: 3;

  @media all and (max-width: 767px) {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
}

.shadows {
  display: none;

  @media all and (max-width: 767px) {
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: -16px;
    z-index: 3;
    pointer-events: none;
    position: absolute;

    &::before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      display: block;
      width: 16px;
      z-index: 2;
    }

    &:before {
      transform: rotate(180deg);
      left: 0;
      background-image: linear-gradient(
        270deg,
        #f9f4ef 0%,
        rgba(249, 244, 239, 0) 100%
      );
    }

    &:after {
      right: 0;
      background-image: linear-gradient(
        270deg,
        #f9f4ef 0%,
        rgba(249, 244, 239, 0) 100%
      );
    }
  }
}

.options_drop {
  z-index: 1;
  right: 0;

  @media all and (max-width: 767px) {
    width: 100%;
    top: -100px;
  }

  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 150px;
    height: 50px;
    right: 0;
    top: 85%;
  }
}
</style>